import { ProficiencyLevel } from '@shared/types';

// WHY: Closed 3-state cycle matching the user's click progression:
// none (empty) -> proficient (half dot) -> expertise (full) -> none.
export const PROFICIENCY_CYCLE: ProficiencyLevel[] = ['none', 'proficient', 'expertise'];

export function nextProficiency(value: ProficiencyLevel): ProficiencyLevel {
  const idx = PROFICIENCY_CYCLE.indexOf(value);
  return PROFICIENCY_CYCLE[(idx + 1) % PROFICIENCY_CYCLE.length];
}
